/**
 * @file add-new-products.tsx
 * @module app/modules/uProcure/products/add-new-products
 * @description Implements the add new products interface for UProcure operations.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import clsx from "clsx";
import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { fileValidation } from "../../../../Global/fileValidation";
import Loader from "../../../../Global/loader";
import { success } from "../../../../Global/toast";
import APICallService from "../../../../api/apiCallService";
import { product } from "../../../../api/apiEndPoints";
import { productJSON } from "../../../../api/apiJSON/product";
import {
  Add,
  CartonWithDozens,
  CartonWithPieces,
  DateSelection,
  Dozen,
  MasterProduct,
  MultiLineText,
  MultiSelection,
  Piece,
  SingleLineText,
  SingleSelection,
} from "../../../../utils/constants";
import { catalogue } from "../../../../utils/toast";
import ProductAddedSuccessfully from "../../../modals/ProductAddedSuccessfully";
import ProductGuidelines from "../../../modals/ProductGuidelines";
import ProductAsDraft from "../../../modals/product-as-draft";
import General from "./General";
import PriceDimesions from "./PriceDimensions";
import TechnicalDetails from "./TechnicalDetails";
import ProductImages from "./product-images";
import Method from "../../../../utils/methods";
import RemoveVariants from "../../../modals/remove-variants";
import { useAuth } from "../../auth";
// import { getKey } from "../../../Global/history";
// import { warehouse as warehouseStoreString } from "../../../utils/storeString";
import { useWarehouse } from "../../../context/WarehouseContext";
export const AddNewProduct = () => {
  
  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const [sortClass, setSortClass] = useState({
    name: 1,
    position: 1,
  });
  const [dragId, setDragId] = useState();
  const [modalImage, setModalImage] = useState("");
  const [categories, setCategories] = useState<any>();
  const [variants, setVariants] = useState<any>();
  const [countries, setCountries] = useState<any>();
  const [brands, setBrands] = useState<any>();
  const [technicalFields, setTechnicalFields] = useState<any>();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showVariantModal, setShowVariantModal] = useState(false);
  useEffect(() => {
    (async () => {
      if (!Method.hasPermission(MasterProduct, Add, currentUser)) {
        return window.history.back();
      }
      setFetchLoader(true);
      let apiService = new APICallService(
        product.initProduct,
        "",
        "",
        "",
        "",
        "",
        MasterProduct,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();
      if (response.defaultItems) {
        let catTemp: any = [];
        response.defaultItems.categories.map((catVal: any) => {
          if (catVal.categories.length) {
            catTemp.push(catVal);
          }
        });
        let countries = response.defaultItems.countries;
        const index = countries.findIndex(
          (item: any) => item.name.toLowerCase() === "tanzania"
        );
        if (index > 0) {
          const tanzaniaElement = countries[index];
          countries.splice(index, 1);
          countries.unshift(tanzaniaElement);
        }
        setCategories(catTemp);
        setVariants(response.defaultItems.variants);
        setCountries(countries);
        setBrands(response.defaultItems.brands);
        setTechnicalFields(response.defaultItems.technicalFields);
        setCurrentTab({
          name: "General info",
          content: (
            <General
              onGeneralDataChange={onGeneralDataChange}
              generalData={generalData}
              categories={catTemp}
              countries={response.defaultItems.countries}
              variants={response.defaultItems.variants}
              technicalFields={response.defaultItems.technicalFields}
              brands={response.defaultItems.brands}
              validations={generalDataValidation}
              onValidationChange={onValidationChange}
            />
          ),
          value: 0,
        });
      }
      setFetchLoader(false);
    })();
    // setDisabled(true);
  }, []);
  const navigate = useNavigate();
  const [tab, setTab] = useState([
    {
      name: "General info",
      content: <General />,
      value: 0,
    },
    { name: "Price & dimensions", content: <PriceDimesions />, value: 1 },
    { name: "Technical details", content: <TechnicalDetails />, value: 2 },
    { name: "Product images", content: <ProductImages />, value: 3 },
  ]);
  const [disabled, setDisabled] = useState(false);
  const [generalData, setGeneralData] = useState<any>({
    primaryCategory: "",
    subCategory: "",
    defaultSubCategory: [],
    defaultGroupCategory: [],
    groupCategory: "",
    productTitle: "",
    taxFree: true,
    productTax: "",
    country: "",
    brand: "",
    description: "",
    variants: [],
    noneSelected: false,
    productName: "",
    isDraft: false,
    combinations: [
      {
        title: "",
        dimensions: {
          isOpen: false,
          cartoonDozens: "0",
          piecesDozens: "0",
          cartoonPieces: "0",
          cartoonPrice: null,
          cartoonDiscount: "0",
          cartoonDiscountPrice: null,
          cartoonDimenisionL: null,
          cartoonDimenisionW: null,
          cartoonDimenisionH: null,
          cartoonWeight: null,
          cartoonQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          dozenPrice: null,
          dozenDiscount: "0",
          dozenDiscountPrice: null,
          dozenDimenisionL: null,
          dozenDimenisionW: null,
          dozenDimenisionH: null,
          dozenWeight: null,
          dozenQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          piecePrice: null,
          pieceDiscount: "0",
          pieceDiscountPrice: null,
          pieceDimenisionL: null,
          pieceDimenisionW: null,
          pieceDimenisionH: null,
          pieceWeight: null,
          pieceQuantities: [
            {
              min: 1,
              max: 5,
              discount: null,
            },
          ],
          product: [
            {
              id: CartonWithDozens,
              value: "Carton (Dozens inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: CartonWithPieces,
              value: "Carton (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            {
              id: Dozen,
              value: "Dozen (Pieces inside)",
              isChecked: false,
              isDisabled: false,
            },
            { id: Piece, value: "Pieces", isChecked: false, isDisabled: false },
          ],
          selectedCartoonId: "",
          selectedDozenId: "",
          selectedPiecesId: "",
          images: [],
          imageReader: [],
        },
      },
    ],
    searchTag: {
      inputValue: '',
      options: [],
    },
  });
  const [generalDataValidation, setGeneralDataValidation] = useState<any>({
    primaryCategory: false,
    subCategory: false,
    groupCategory: false,
    productTitle: false,
    country: false,
    brand: false,
    description: false,
    variants: false,
    noneSelected: false,
    productName: false,
    productTax: false,
    isDraft: false,
    minimumCombinations: false,
    selectedVariants: [],
    combinations: [
      {
        title: false,
        dimensions: {
          cartoonDozens: false,
          piecesDozens: false,
          cartoonPieces: false,
          cartoonPrice: false,
          cartoonDiscount: false,
          cartoonDiscountPrice: false,
          cartoonDimenisionL: false,
          cartoonDimenisionW: false,
          cartoonDimenisionH: false,
          cartoonWeight: false,
          cartoonQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          dozenPrice: false,
          dozenDiscount: false,
          dozenDiscountPrice: false,
          dozenDimenisionL: false,
          dozenDimenisionW: false,
          dozenDimenisionH: false,
          dozenWeight: false,
          dozenQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
          piecePrice: false,
          pieceDiscount: false,
          pieceDiscountPrice: false,
          pieceDimenisionL: false,
          pieceDimenisionW: false,
          pieceDimenisionH: false,
          pieceWeight: false,
          pieceQuantities: [
            {
              min: false,
              max: false,
              discount: false,
            },
          ],
        },
        validation: false,
      },
    ],
  });
  const [priceValidation, setPriceValidation] = useState(false);
  const onGeneralDataChange = (data: any) => {
    setGeneralData(data);
  };
  const onValidationChange = (data: any) => {
    setGeneralDataValidation(data);
  };
  const [imageString, setImageString] = useState();
  const [productAsDraftmodalShow, setProductAsDraftModalShow] = useState(false);
  const [productAddedmodalShow, setProductAddedModalShow] = useState(false);
  const [productGuidelinesmodalShow, setProductGuidelinesModalShow] =
    useState(false);
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <span
            className={clsx(
              "nav-link disabled text-active-dark",
              current.name === tab.name ? "active" : " ",
              currentTab.value !== tab.value
                ? disabled
                  ? "disabled"
                  : ""
                : "",
              loading ? "disabled" : ""
            )}
          >
            {tab.name}
          </span>
        </li>
      );
    });
    return allTabs;
  };
  const handleSelectTab = async (tab: any) => {
    let generalTemp = JSON.parse(JSON.stringify({ ...generalData }));
    console.log("tab.value", tab.value);
    if (tab.value === 1 && currentTab.value === 0) {
      let generalTabValidations = await checkGeneralTabValidation(generalTemp);
      if (!generalTabValidations) {
        let selectedVariant: any = [];
        let data: any = [];
        let validations = JSON.parse(
          JSON.stringify({ ...generalDataValidation })
        );
        generalTemp.variants.map((variantVal: any) => {
          if (variantVal.isSelected === true) {
            let temp: any = [];
            variantVal.categories[0].options.map((optionVal: any) => {
              temp.push({ title: optionVal.title, _id: variantVal._id });
            });
            selectedVariant.push({
              options: variantVal.categories[0].options,
              _id: variantVal._id,
            });
            data.push(temp);
          }
        });
        if (!generalTemp.noneSelected) {
          let temp = { ...generalTemp };
          if (selectedVariant.length) {
            temp.selectedVariant = selectedVariant;
            if (data.length) {
              if (data[0].length === 0) {
                let imageString: any = [];
                data[0].map((val: any) =>
                  imageString.push({
                    title: `${generalTemp.productTitle} (${val.title})`,
                    id: val._id,
                  })
                );
                let tempData: any = [];
                let validTemp: any = [];
                imageString.map((val: any) => {
                  validTemp.push({
                    title: false,
                    validation: false,
                    dimensions: validations.combinations[0].dimensions,
                  });
                  return tempData.push({
                    title: val.title,
                    id: val.id,
                    dimensions: generalTemp.combinations[0].dimensions,
                  });
                });
                validations.combinations = validTemp;
                temp.combinations = tempData;
                setGeneralData(temp);
                setGeneralDataValidation(validations);
                setNavTab(tab.value, temp, validations);
              } else {
                let imageString = await combine(data);
                let updatedImageString = imageString.map((val: any) => {
                  return {
                    id: val._id,
                    title: `${generalTemp.productTitle} (${val.title})`,
                  };
                });
                let tempData: any = [];
                let validTemp: any = [];
                updatedImageString.map((val: any, index: any) => {
                  validTemp.push({
                    title: false,
                    dimensions:
                      generalDataValidation.combinations[0].dimensions,
                  });
                  return tempData.push({
                    title: val.title,
                    id: val.id,
                    dimensions: {
                      cartoonDozens: "0",
                      piecesDozens: "0",
                      cartoonPieces: "0",
                      cartoonPrice: null,
                      cartoonDiscount: "0",
                      cartoonDiscountPrice: null,
                      cartoonDimenisionL: null,
                      cartoonDimenisionW: null,
                      cartoonDimenisionH: null,
                      cartoonWeight: null,
                      cartoonQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: null,
                        },
                      ],
                      dozenPrice: null,
                      dozenDiscount: "0",
                      dozenDiscountPrice: null,
                      dozenDimenisionL: null,
                      dozenDimenisionW: null,
                      dozenDimenisionH: null,
                      dozenWeight: null,
                      dozenQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: null,
                        },
                      ],
                      piecePrice: null,
                      pieceDiscount: "0",
                      pieceDiscountPrice: null,
                      pieceDimenisionL: null,
                      pieceDimenisionW: null,
                      pieceDimenisionH: null,
                      pieceWeight: null,
                      pieceQuantities: [
                        {
                          min: 1,
                          max: 5,
                          discount: null,
                        },
                      ],
                      product: [
                        {
                          id: CartonWithDozens,
                          value: "Carton (Dozens inside)",
                          isChecked: false,
                          isDisabled: false,
                        },
                        {
                          id: CartonWithPieces,
                          value: "Carton (Pieces inside)",
                          isChecked: false,
                          isDisabled: false,
                        },
                        {
                          id: Dozen,
                          value: "Dozen (Pieces inside)",
                          isChecked: false,
                          isDisabled: false,
                        },
                        {
                          id: Piece,
                          value: "Pieces",
                          isChecked: false,
                          isDisabled: false,
                        },
                      ],
                      selectedCartoonId: "",
                      selectedDozenId: "",
                      selectedPiecesId: "",
                      isOpen: false,
                      images: [],
                      imageReader: [],
                    },
                    validation: false,
                  });
                });
                temp.combinations = tempData;
                validations.combinations = validTemp;
                setGeneralDataValidation(validations);
                setGeneralData(temp);
                setNavTab(tab.value, temp, validations);
              }
            } else {
              let tempData: any = [];
              let validTemp: any = [];
              tempData.push({
                title: generalTemp.productTitle,
                id: "",
                dimensions: generalTemp.combinations[0].dimensions,
              });
              validTemp.push({
                title: false,
                dimensions: generalDataValidation.combinations[0].dimensions,
                validation: false,
              });
              temp.combinations = tempData;
              validations.combinations = validTemp;
              setGeneralDataValidation(validations);
              setNavTab(tab.value, temp, validations);
            }
          }
          if (tab.value > currentTab.value) {
            if (temp.combinations.length > 1) setShowVariantModal(true);
            else setNavTab(tab.value, temp, validations);
          } else {
            setNavTab(tab.value, temp, validations);
          }
        } else {
          let validations = { ...generalDataValidation };
          let tempData: any = [];
          let validTemp: any = [];
          tempData.push({
            title: generalTemp.productTitle,
            dimensions: generalTemp.combinations[0].dimensions,
          });
          validTemp.push({
            title: false,
            dimensions: generalDataValidation.combinations[0].dimensions,
            validation: false,
          });
          validations.combinations = validTemp;
          generalTemp.combinations = tempData;
          setGeneralDataValidation(validations);
          setNavTab(tab.value, generalTemp, validations);
        }
      }
    } else if (tab.value === 2) {
      let priceDimensionTabValidations = await checkPriceDimensionTabValidation(
        generalTemp
      );
      if (!priceDimensionTabValidations) {
        let validations = JSON.parse(
          JSON.stringify({ ...generalDataValidation })
        );
        if (generalTemp.defaultTechnicalFields.length === 0) {
          let filterTechnical: any = [];
          let filterTechnicalValidation: any = [];
          technicalFields.map((techVal: any) => {
            if (techVal.category === generalTemp.primaryCategory) {
              let temp: any = [];
              if (techVal.options.length) {
                techVal.options.map((optionsVal: any) => {
                  temp.push({
                    ...optionsVal,
                    value: optionsVal.title,
                    label: optionsVal.title,
                  });
                });
              }
              filterTechnical.push({ ...techVal, options: temp });
              filterTechnicalValidation.push({ valid: false });
            }
          });
          if (generalTemp.defaultTechnicalFields.length === 0) {
            generalTemp.defaultTechnicalFields = filterTechnical;
          }
          generalDataValidation.defaultTechnicalFields =
            filterTechnicalValidation;
        }
        setGeneralData(generalTemp);
        setGeneralDataValidation(generalDataValidation);
        setNavTab(tab.value, generalTemp, generalDataValidation);
      }
    } else if (tab.value === 3) {
      let generalTabValidations = await checkGeneralTabValidation(generalTemp);
      let priceDimensionTabValidations = await checkPriceDimensionTabValidation(
        generalTemp
      );
      let technicalTabValidations = await checkTechnicalDetailsValiadtions(
        generalTemp
      );
      if (
        !generalTabValidations &&
        !priceDimensionTabValidations &&
        !technicalTabValidations
      ) {
        let data: any = [];
        let selectedVariant: any = [];
        generalTemp.variants.map((variantVal: any) => {
          if (variantVal.isSelected === true) {
            let temp: any = [];
            variantVal.categories[0].options.map((optionVal: any) => {
              temp.push({ title: optionVal.title, _id: variantVal._id });
            });
            selectedVariant.push({
              options: variantVal.categories[0].options,
              _id: variantVal._id,
            });
            data.push(temp);
          }
        });
        if (!generalTemp.noneSelected) {
          generalTemp.selectedVariant = selectedVariant;
          let validations = JSON.parse(
            JSON.stringify({ ...generalDataValidation })
          );
          if (data.length) {
            if (data[0].length === 0) {
              let imageString: any = [];
              data[0].map((val: any) =>
                imageString.push({
                  title: `${generalTemp.productTitle} (${val.title})`,
                  id: val._id,
                })
              );
              let tempData: any = [];
              let validTemp: any = [];
              imageString.map((val: any, index: number) => {
                validTemp.push({
                  title: false,
                  dimensions: validations.combinations[0].dimensions,
                  validation: false,
                });
                return tempData.push({
                  title: val.title,
                  id: val.id,
                  dimensions: generalTemp.combinations[index]
                    ? generalTemp.combinations[index].dimensions
                    : generalTemp.combinations[0].dimensions,
                });
              });
              validations.combinations = validTemp;
              generalTemp.combinations = tempData;
              setGeneralData(generalTemp);
              setGeneralDataValidation(validations);
              setNavTab(tab.value, generalTemp, validations);
            } else {
              let imageString = await combine(data);
              let updatedImageString = imageString.map((val: any) => {
                return {
                  id: val._id,
                  title: `${generalTemp.productTitle} (${val.title})`,
                };
              });
              let tempData: any = [];
              let validTemp: any = [];
              updatedImageString.map((val: any, index: number) => {
                validTemp.push({
                  title: false,
                  dimensions: generalDataValidation.combinations[0].dimensions,
                  validation: false,
                });
                return tempData.push({
                  title: val.title,
                  id: val.id,
                  dimensions: generalTemp.combinations[index]
                    ? generalTemp.combinations[index].dimensions
                    : generalTemp.combinations[0].dimensions,
                });
              });
              generalTemp.combinations = tempData;
              validations.combinations = validTemp;
              setGeneralDataValidation(validations);
              setGeneralData(generalTemp);
              setNavTab(tab.value, generalTemp, validations);
            }
          } else {
            let tempData: any = [];
            let validTemp: any = [];
            tempData.push({
              title: generalTemp.productTitle,
              id: "",
              dimensions: generalTemp.combinations[0].dimensions,
            });
            validTemp.push({
              title: false,
              dimensions: generalDataValidation.combinations[0].dimensions,
              validation: false,
            });
            generalTemp.combinations = tempData;
            validations.combinations = validTemp;
            setGeneralDataValidation(validations);
            setNavTab(tab.value, generalTemp, validations);
          }
          setNavTab(tab.value, generalTemp, validations);
        } else {
          let validations = { ...generalDataValidation };
          let tempData: any = [];
          let validTemp: any = [];
          tempData.push({
            title: generalTemp.productTitle,
            dimensions: generalTemp.combinations[0].dimensions,
          });
          validTemp.push({
            title: false,
            dimensions: generalDataValidation.combinations[0].dimensions,
            validation: false,
          });
          validations.combinations = validTemp;
          generalTemp.combinations = tempData;
          setGeneralDataValidation(validations);
          setNavTab(tab.value, generalTemp, validations);
        }
      }
    } else if (tab.value === 4) {
      setNavTab(tab.value, generalTemp, generalDataValidation);
    } else {
      setNavTab(tab.value, generalTemp, generalDataValidation);
    }
  };
  const checkGeneralTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = JSON.parse(
      JSON.stringify({ ...generalDataValidation })
    );
    let valid = [];
    if (generalDataTemp.primaryCategory === "") {
      generalValidationTemp.primaryCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.taxFree === false) {
      if (generalDataTemp.productTax === "") {
        generalValidationTemp.productTax = true;
        valid.push(true);
      }
    }
    if (generalDataTemp.subCategory === "") {
      generalValidationTemp.subCategory = true;
      valid.push(true);
    }
    if (generalDataTemp.productTitle === "") {
      valid.push(true);
      generalValidationTemp.productTitle = true;
    }
    if (generalDataTemp.country === "") {
      generalValidationTemp.country = true;
      valid.push(true);
    }
    if (generalDataTemp.brand === "") {
      valid.push(true);
      generalValidationTemp.brand = true;
    }
    if (generalDataTemp.description === "") {
      valid.push(true);
      generalValidationTemp.description = true;
    }
    let selectedVariant: any = [];
    let data: any = [];
    let validations = JSON.parse(JSON.stringify({ ...generalDataValidation }));
    generalDataTemp.variants.map((variantVal: any) => {
      if (variantVal.isSelected === true) {
        let temp: any = [];
        variantVal.categories[0].options.map((optionVal: any) => {
          temp.push({ title: optionVal.title, _id: variantVal._id });
        });
        selectedVariant.push({
          options: variantVal.categories[0].options,
          _id: variantVal._id,
        });
        validations.selectedVariants.push(false);
        data.push(temp);
      }
    });
    if (!generalDataTemp.noneSelected) {
      if (selectedVariant.length) {
        let selectValTemp: any = [];
        selectedVariant.map((selectVal: any) => {
          if (selectVal.options.length) {
            selectValTemp.push(false);
          } else {
            valid.push(true);
            selectValTemp.push(true);
          }
        });
        generalValidationTemp.selectedVariants = selectValTemp;
      } else {
        valid.push(true);
        generalValidationTemp.variants = true;
      }
    } else {
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkPriceDimensionTabValidation = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid = [];
    if (generalDataTemp.combinations.length) {
      let allTrue = generalDataTemp.combinations.some(({ dimensions }: any) =>
        dimensions.product.some(({ isChecked }: any) => isChecked === true)
      );
      generalDataTemp.combinations.map(({ dimensions }: any, index: number) => {
        generalDataValidation.combinations[index].validation =
          !dimensions.product.some(({ isChecked }: any) => isChecked === true);
      });
      if (!allTrue) {
        valid.push(true);
        generalDataValidation.minimumCombinations = true;
      } else {
        generalDataValidation.minimumCombinations = false;
        generalDataTemp.combinations.map((combVal: any, index: number) => {
          let combinationValidation: any = [];
          if (combVal.dimensions.product[0].isChecked) {
            if (
              !combVal.dimensions.cartoonDozens ||
              combVal.dimensions.cartoonDozens === "" ||
              combVal.dimensions.cartoonDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDozens = true;
            }
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.piecesDozens ||
              combVal.dimensions.piecesDozens === "" ||
              combVal.dimensions.piecesDozens == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.piecesDozens = true;
            }
          }
          if (combVal.dimensions.product[1].isChecked) {
            if (
              !combVal.dimensions.cartoonPieces ||
              combVal.dimensions.cartoonPieces === "" ||
              combVal.dimensions.cartoonPieces == 0
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPieces = true;
            }
          }
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            if (
              !combVal.dimensions.cartoonPrice ||
              combVal.dimensions.cartoonPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonPrice = true;
            }
            if (combVal.dimensions.cartoonDiscount === "0") {
              if (
                combVal.dimensions.cartoonDiscountPrice &&
                combVal.dimensions.cartoonDiscountPrice !== "" &&
                combVal.dimensions.cartoonPrice &&
                combVal.dimensions.cartoonPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.cartoonDiscountPrice) >
                  parseInt(combVal.dimensions.cartoonPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.cartoonDiscountPrice = true;
                }
              }
            } else {
              if (combVal.dimensions.cartoonQuantities.length) {
              }
            }
            if (
              !combVal.dimensions.cartoonDimenisionL ||
              combVal.dimensions.cartoonDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionL = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionW ||
              combVal.dimensions.cartoonDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionW = true;
            }
            if (
              !combVal.dimensions.cartoonDimenisionH ||
              combVal.dimensions.cartoonDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonDimenisionH = true;
            }
            if (
              !combVal.dimensions.cartoonWeight ||
              combVal.dimensions.cartoonWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.cartoonWeight = true;
            }
          }
          if (combVal.dimensions.product[2].isChecked) {
            if (
              !combVal.dimensions.dozenPrice ||
              combVal.dimensions.dozenPrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenPrice =
                true;
            }
            if (combVal.dimensions.dozenDiscount === "0") {
              if (
                combVal.dimensions.dozenDiscountPrice &&
                combVal.dimensions.dozenDiscountPrice !== "" &&
                combVal.dimensions.dozenPrice &&
                combVal.dimensions.dozenPrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.dozenDiscountPrice) >
                  parseInt(combVal.dimensions.dozenPrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.dozenDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.dozenDimenisionL ||
              combVal.dimensions.dozenDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionL = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionW ||
              combVal.dimensions.dozenDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionW = true;
            }
            if (
              !combVal.dimensions.dozenDimenisionH ||
              combVal.dimensions.dozenDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.dozenDimenisionH = true;
            }
            if (
              !combVal.dimensions.dozenWeight ||
              combVal.dimensions.dozenWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.dozenWeight =
                true;
            }
          }
          if (combVal.dimensions.product[3].isChecked) {
            if (
              !combVal.dimensions.piecePrice ||
              combVal.dimensions.piecePrice === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.piecePrice =
                true;
            }
            if (combVal.dimensions.pieceDiscount === "0") {
              if (
                combVal.dimensions.pieceDiscountPrice &&
                combVal.dimensions.pieceDiscountPrice !== "" &&
                combVal.dimensions.piecePrice &&
                combVal.dimensions.piecePrice !== ""
              ) {
                if (
                  parseInt(combVal.dimensions.pieceDiscountPrice) >
                  parseInt(combVal.dimensions.piecePrice)
                ) {
                  valid.push(true);
                  combinationValidation.push(true);
                  generalDataValidation.combinations[
                    index
                  ].dimensions.pieceDiscountPrice = true;
                }
              }
            }
            if (
              !combVal.dimensions.pieceDimenisionL ||
              combVal.dimensions.pieceDimenisionL === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionL = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionW ||
              combVal.dimensions.pieceDimenisionW === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionW = true;
            }
            if (
              !combVal.dimensions.pieceDimenisionH ||
              combVal.dimensions.pieceDimenisionH === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[
                index
              ].dimensions.pieceDimenisionH = true;
            }
            if (
              !combVal.dimensions.pieceWeight ||
              combVal.dimensions.pieceWeight === ""
            ) {
              valid.push(true);
              combinationValidation.push(true);
              generalDataValidation.combinations[index].dimensions.pieceWeight =
                true;
            }
          }
          let result = combinationValidation.some((el: any) => {
            return el === true;
          });
          generalValidationTemp.combinations[index].validation = result;
        });
      }
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el) => {
      return el === true;
    });
    return validationResult;
  };
  const checkTechnicalDetailsValiadtions = async (generalDataTemp: any) => {
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    if (
      generalDataTemp.defaultTechnicalFields &&
      generalDataTemp.defaultTechnicalFields.length
    ) {
      generalDataTemp.defaultTechnicalFields.map(
        (techVal: any, techIndex: number) => {
          if (
            techVal.type === SingleLineText ||
            techVal.type === MultiLineText
          ) {
            if (
              techVal.answer === undefined ||
              techVal.answer === null ||
              techVal.answer === ""
            ) {
              valid.push(true);
              generalDataValidation.defaultTechnicalFields[techIndex]["valid"] =
                true;
            }
            // form.append("technicalInfo["+techIndex+"][answer]",techVal.answer);
          }
          if (
            techVal.type === MultiSelection ||
            techVal.type === SingleSelection
          ) {
            if (
              techVal.selectedOptions === undefined ||
              techVal.selectedOptions === null ||
              techVal.selectedOptions.length === 0
            ) {
              valid.push(true);
              generalDataValidation.defaultTechnicalFields[techIndex]["valid"] =
                true;
            }
          }
        }
      );
    }
    setGeneralDataValidation(generalValidationTemp);
    let validationResult = valid.some((el: any) => {
      return el === true;
    });
    return validationResult;
  };
  const handlePreviousSelectTab = async (tab: any) => {
    setNavTab(tab.value, generalData, generalDataValidation);
  };
  const handleImage = async (event: any, index: number) => {
    const selectedFiles = event.target.files;
    let temp = { ...generalData };
    if (!selectedFiles) return;
    else {
      let temp2 = JSON.parse(JSON.stringify(temp));
      let generalValidationTemp = JSON.parse(
        JSON.stringify({ ...generalDataValidation })
      );
      let imageTemp: any = [];
      for (let i = 0; i < selectedFiles.length; i++) {
        if (fileValidation(selectedFiles?.[i])) {
          await toBase64(selectedFiles?.[i]).then((data) => {
            temp2.combinations[index].dimensions.images.push({
              url: URL.createObjectURL(selectedFiles?.[i]),
              obj: data,
              order: i,
              id: i,
            });
          });
        }
      }
      await setGeneralData(temp2);
      generalValidationTemp.combinations[index].dimensions.images = false;
      await setGeneralDataValidation(generalValidationTemp);
    }
  };
  const handleDrag = async (ev: any) => {
    await setDragId(ev.currentTarget.id);
  };
  const handleDrop = async (event: any, index: number, imageIndex: number) => {
    let temp = JSON.parse(JSON.stringify({ ...generalData }));
    const dragBox = temp.combinations[index].dimensions.images.find(
      (box: any) => {
        return box.id == dragId;
      }
    );
    const dropBox = temp.combinations[index].dimensions.images.find(
      (box: any) => box.id == event.currentTarget.id
    );
    const dragBoxOrder = dragBox.order;
    const dropBoxOrder = dropBox.order;
    const newBoxState = temp.combinations[index].dimensions.images.map(
      (box: any) => {
        if (box.id == dragId) {
          box.order = dropBoxOrder;
        }
        if (box.id == event.currentTarget.id) {
          box.order = dragBoxOrder;
        }
        return box;
      }
    );
    temp.combinations[index].dimensions.images = newBoxState;
    await setGeneralData(temp);
  };
  const toBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleRemoveImage = (index: number, productIndex: number) => {
    let temp = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    let data = temp.combinations[index];
    let updatedImage = data.dimensions.images.filter(
      (e: any, i: number) => i !== productIndex
    );
    let updatedImageReader = data.dimensions.imageReader.filter(
      (e: any, i: number) => i !== productIndex
    );
    if (!updatedImage.length) {
      generalValidationTemp.combinations[index].dimensions.images = true;
    }
    data.dimensions.images = updatedImage;
    data.dimensions.imageReader = updatedImageReader;
    setGeneralDataValidation(generalValidationTemp);
    setGeneralData(temp);
  };
  const handleSubmit = async () => {
    let temp: any = { ...generalData };
    let generalValidationTemp = { ...generalDataValidation };
    let valid: any = [];
    temp.combinations.map((combVal: any, index: number) => {
      if (
        combVal.dimensions.product[0].isChecked ||
        combVal.dimensions.product[1].isChecked ||
        combVal.dimensions.product[2].isChecked ||
        combVal.dimensions.product[3].isChecked
      ) {
        if (!combVal.dimensions.images.length) {
          generalValidationTemp.combinations[index].dimensions.images = true;
          valid.push(true);
        }
      }
    });
    setGeneralDataValidation(generalValidationTemp);
    let checked = valid.some((el: any) => {
      return el === true;
    });
    if (!checked) {
      setLoading(true);
      let updatedObject: any = {
        primaryCategory: temp.primaryCategory,
        subCategory: temp.subCategory,
        productTitle: temp.productTitle,
        isDraft: false,
        taxFree: temp.taxFree,
        searchTag:temp.searchTag
      };
      if (temp.country)
        updatedObject = { ...updatedObject, country: temp.country };
      if (temp.groupCategory)
        updatedObject = { ...updatedObject, groupCategory: temp.groupCategory };
      if (temp.brand) updatedObject = { ...updatedObject, brand: temp.brand };
      if (temp.description)
        updatedObject = { ...updatedObject, description: temp.description };
      if (!temp.taxFree)
        updatedObject = { ...updatedObject, productTax: temp.productTax };
      if (temp.selectedVariant && temp.selectedVariant.length) {
        updatedObject = {
          ...updatedObject,
          selectedVariant: temp.selectedVariant,
        };
      }
      if (temp.combinations.length) {
        let combinationTemp: any = [];
        temp.combinations.map((combVal: any, combIndex: number) => {
          let innerTemp: any = {
            piecesDozens: combVal.dimensions.piecesDozens,
            cartoonDozens: combVal.dimensions.cartoonDozens,
            cartoonPieces: combVal.dimensions.cartoonPieces,
          };
          if (
            combVal.dimensions.product[0].isChecked ||
            combVal.dimensions.product[1].isChecked
          ) {
            innerTemp = {
              ...innerTemp,
              cartonWithDozens: combVal.dimensions.product[0].isChecked,
              cartonWithPieces: combVal.dimensions.product[1].isChecked,
              cartoonPrice: combVal.dimensions.cartoonPrice,
              cartoonDiscount: combVal.dimensions.cartoonDiscount,
              cartoonDiscountPrice: combVal.dimensions.cartoonDiscountPrice,
              cartoonDimenisionL: combVal.dimensions.cartoonDimenisionL,
              cartoonDimenisionW: combVal.dimensions.cartoonDimenisionW,
              cartoonDimenisionH: combVal.dimensions.cartoonDimenisionH,
              cartoonWeight: combVal.dimensions.cartoonWeight,
              cartoonQuantities: combVal.dimensions.cartoonQuantities,
            };
          }
          if (combVal.dimensions.product[2].isChecked) {
            innerTemp = {
              ...innerTemp,
              dozenChecked: true,
              dozenPrice: combVal.dimensions.dozenPrice,
              dozenDiscount: combVal.dimensions.dozenDiscount,
              dozenDiscountPrice: combVal.dimensions.dozenDiscountPrice,
              dozenDimenisionL: combVal.dimensions.dozenDimenisionL,
              dozenDimenisionW: combVal.dimensions.dozenDimenisionW,
              dozenDimenisionH: combVal.dimensions.dozenDimenisionH,
              dozenWeight: combVal.dimensions.dozenWeight,
              dozenQuantities: combVal.dimensions.dozenQuantities,
            };
          }
          if (combVal.dimensions.product[3].isChecked) {
            innerTemp = {
              ...innerTemp,
              pieceChecked: true,
              piecePrice: combVal.dimensions.piecePrice,
              pieceDiscount: combVal.dimensions.pieceDiscount,
              pieceDiscountPrice: combVal.dimensions.pieceDiscountPrice,
              pieceDimenisionL: combVal.dimensions.pieceDimenisionL,
              pieceDimenisionW: combVal.dimensions.pieceDimenisionW,
              pieceDimenisionH: combVal.dimensions.pieceDimenisionH,
              pieceWeight: combVal.dimensions.pieceWeight,
              pieceQuantities: combVal.dimensions.pieceQuantities,
            };
          }
          let variantsSelected: any = [];
          if (combVal.id) {
            // let selectedVariantsId: any = combVal.id.split('-');
            // let selectedVariantsTitle: any = combVal.title
            //   .split('(')[1]
            //   .replace(')', ' ')
            //   .split(',');
            // selectedVariantsId.map((val: any, index: number) => {
            //   variantsSelected.push({
            //     id: val,
            //     title: selectedVariantsTitle[index].replace(/\s*\)\s*/g, ')'),
            //   });
            // });
            let selectedVariantsId: any = combVal.id.split("-");
            // let selectedVariantsTitle: any = combVal.title
            //   .split('(')[1]
            //   .replace(')', ' ')
            //   .split(',')
            // selectedVariantsId.map((val: any, index: number) => {
            //   variantsSelected.push({
            //     id: val,
            //     title: selectedVariantsTitle[index],
            //   })
            // })
            const innerText = extractTextWithinParentheses(combVal.title);
            // Split the inner text by ',' to get an array of titles
            const selectedVariantsTitle = innerText.split(",");
            selectedVariantsId.forEach((val: any, index: number) => {
              variantsSelected.push({
                id: val,
                title:
                  selectedVariantsTitle[index % selectedVariantsTitle.length], // Use modulo to cycle through selectedVariantsTitle
              });
            });
          }
          if (Object.keys(innerTemp).length) {
            innerTemp = {
              ...innerTemp,
              images: combVal.dimensions.images,
              imageReader: combVal.dimensions.imageReader,
              selectedCombinations: variantsSelected,
            };
            combinationTemp.push(innerTemp);
          }
        });
        updatedObject = { ...updatedObject, combinations: combinationTemp };
      }
      if (temp.defaultTechnicalFields && temp.defaultTechnicalFields.length) {
        temp.defaultTechnicalFields.map((val: any) => {
          if (val.type === DateSelection) {
            if (
              val.answer === undefined ||
              val.answer === "undefined" ||
              val.answer === ""
            ) {
              val.answer = Method.currentLocalDateTime();
            }
          }
        });
        updatedObject = {
          ...updatedObject,
          defaultTechnicalFields: temp.defaultTechnicalFields,
        };
      }
      let modalImageTemp = updatedObject.combinations[0].images[0].url;
      setModalImage(modalImageTemp);
      let apiService = new APICallService(
        product.addProduct,
        productJSON.addProduct({ product: updatedObject }),
        "",
        "",
        "",
        "",
        MasterProduct,
        selectedWarehouse?.value
      );
      let response = await apiService.callAPI();
      if (response) {
        success(catalogue.added);
        setProductAddedModalShow(true);
         
      }
      setLoading(false);
    }
  };
  function extractTextWithinParentheses(str: string): string {
    // let depth = 0
    // let result = ''
    // let withinParentheses = false
    // for (let i = 0; i < str.length; i++) {
    //   if (str[i] === '(') {
    //     if (!withinParentheses) {
    //       result += '(' // Include '(' if it's the start of innermost parentheses
    //     }
    //     depth++
    //     withinParentheses = true
    //   } else if (str[i] === ')') {
    //     depth--
    //     if (depth === 0) {
    //       return result // Return the result if we reach the end of innermost parentheses
    //     }
    //   } else if (withinParentheses) {
    //     result += str[i]
    //   }
    // }
    // return result
    let depth = 0;
    let result = "";
    let withinParentheses = false;
    for (let i = 0; i < str.length; i++) {
      if (str[i] === "(") {
        if (depth > 0) {
          result += "("; // Include '(' if it's inside the innermost parentheses
        }
        depth++;
        withinParentheses = true;
      } else if (str[i] === ")") {
        depth--;
        if (depth === 0) {
          withinParentheses = false;
        }
        if (depth > 0) {
          result += ")"; // Include ')' if it's inside the innermost parentheses
        }
      } else if (withinParentheses) {
        result += str[i];
      }
    }
    return result;
  }
  const combine = ([head, ...[headTail, ...tailTail]]: any): any => {
    if (!headTail) return head;
    const combined = headTail.reduce((acc: any, x: any) => {
      return acc.concat(
        head.map((h: any) => {
          let data = {
            title: `${h.title},${x.title}`,
            _id: `${h._id}-${x._id}`,
          };
          return data;
        })
      );
    }, []);
    return combine([combined, ...tailTail]);
  };
  const setNavTab = (value: any, data?: any, validations?: any) => {
    let tabTemp = [...tab];
    let currentTab = {};
    switch (value) {
      case 0:
        currentTab = {
          name: "General info",
          content: (
            <General
              onGeneralDataChange={onGeneralDataChange}
              generalData={generalData}
              categories={categories}
              countries={countries}
              variants={variants}
              technicalFields={technicalFields}
              brands={brands}
              validations={validations}
              onValidationChange={onValidationChange}
            />
          ),
          value: 0,
        };
        break;
      case 3:
        currentTab = {
          name: "Product images",
          content: (
            <ProductImages
              generalData={generalData}
              handleImage={(event: any, index: any) => {
                handleImage(event, index);
              }}
              handleRemoveImage={handleRemoveImage}
              validations={validations}
              onValidationChange={onValidationChange}
              onGeneralDataChange={onGeneralDataChange}
              loading={loading}
              handleDrag={handleDrag}
              handleDrop={handleDrop}
            />
          ),
          value: 3,
        };
        break;
      case 2:
        currentTab = {
          name: "Technical details",
          content: (
            <TechnicalDetails
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              validations={validations}
              onValidationChange={onValidationChange}
            />
          ),
          value: 2,
        };
        break;
      case 1:
        currentTab = {
          name: "Price & dimensions",
          content: (
            <PriceDimesions
              onGeneralDataChange={onGeneralDataChange}
              generalData={data}
              validations={validations}
              onValidationChange={onValidationChange}
              priceValidation={priceValidation}
            />
          ),
          value: 1,
        };
        break;
      default:
        break;
    }
    setCurrentTab(currentTab);
    setTab(tabTemp);
  };
  const [currentTab, setCurrentTab] = useState<any>({
    name: "General info",
    content: (
      <General
        onGeneralDataChange={onGeneralDataChange}
        generalData={generalData}
        categories={categories}
        countries={countries}
        variants={variants}
        technicalFields={technicalFields}
        brands={brands}
        validations={generalDataValidation}
        onValidationChange={onValidationChange}
      />
    ),
    value: 0,
  });
  useEffect(() => {
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalData]);
  useEffect(() => {
    setNavTab(currentTab.value, generalData, generalDataValidation);
  }, [generalDataValidation]);
  const onSaveAsDraft = async () => {
    setLoading(true);
    let temp: any = { ...generalData };
    let updatedObject: any = {
      primaryCategory: temp.primaryCategory,
      subCategory: temp.subCategory,
      productTitle: temp.productTitle,
      isDraft: true,
      taxFree: temp.taxFree,
    };
    if (!temp.taxFree)
      updatedObject = { ...updatedObject, productTax: temp.productTax };
    if (temp.country)
      updatedObject = { ...updatedObject, country: temp.country };
    if (temp.groupCategory)
      updatedObject = { ...updatedObject, groupCategory: temp.groupCategory };
    if (temp.brand) updatedObject = { ...updatedObject, brand: temp.brand };
    if (temp.description)
      updatedObject = { ...updatedObject, description: temp.description };
    if (temp.selectedVariant && temp.selectedVariant.length) {
      updatedObject = {
        ...updatedObject,
        selectedVariant: temp.selectedVariant,
      };
    }
    if (temp.combinations.length) {
      let combinationTemp: any = [];
      temp.combinations.map((combVal: any, combIndex: number) => {
        let innerTemp: any = {
          piecesDozens: combVal.dimensions.piecesDozens,
          cartoonDozens: combVal.dimensions.cartoonDozens,
          cartoonPieces: combVal.dimensions.cartoonPieces,
        };
        if (
          combVal.dimensions.product[0].isChecked ||
          combVal.dimensions.product[1].isChecked
        ) {
          innerTemp = {
            ...innerTemp,
            cartonWithDozens: combVal.dimensions.product[0].isChecked,
            cartonWithPieces: combVal.dimensions.product[1].isChecked,
            cartoonPrice: combVal.dimensions.cartoonPrice,
            cartoonDiscount: combVal.dimensions.cartoonDiscount,
            cartoonDiscountPrice: combVal.dimensions.cartoonDiscountPrice,
            cartoonDimenisionL: combVal.dimensions.cartoonDimenisionL,
            cartoonDimenisionW: combVal.dimensions.cartoonDimenisionW,
            cartoonDimenisionH: combVal.dimensions.cartoonDimenisionH,
            cartoonWeight: combVal.dimensions.cartoonWeight,
            cartoonQuantities: combVal.dimensions.cartoonQuantities,
          };
        }
        if (combVal.dimensions.product[2].isChecked) {
          innerTemp = {
            ...innerTemp,
            dozenChecked: true,
            dozenPrice: combVal.dimensions.dozenPrice,
            dozenDiscount: combVal.dimensions.dozenDiscount,
            dozenDiscountPrice: combVal.dimensions.dozenDiscountPrice,
            dozenDimenisionL: combVal.dimensions.dozenDimenisionL,
            dozenDimenisionW: combVal.dimensions.dozenDimenisionW,
            dozenDimenisionH: combVal.dimensions.dozenDimenisionH,
            dozenWeight: combVal.dimensions.dozenWeight,
            dozenQuantities: combVal.dimensions.dozenQuantities,
          };
        }
        if (combVal.dimensions.product[3].isChecked) {
          innerTemp = {
            ...innerTemp,
            pieceChecked: true,
            piecePrice: combVal.dimensions.piecePrice,
            pieceDiscount: combVal.dimensions.pieceDiscount,
            pieceDiscountPrice: combVal.dimensions.pieceDiscountPrice,
            pieceDimenisionL: combVal.dimensions.pieceDimenisionL,
            pieceDimenisionW: combVal.dimensions.pieceDimenisionW,
            pieceDimenisionH: combVal.dimensions.pieceDimenisionH,
            pieceWeight: combVal.dimensions.pieceWeight,
            pieceQuantities: combVal.dimensions.pieceQuantities,
          };
        }
        let variantsSelected: any = [];
        if (combVal.id) {
          let selectedVariantsId: any = combVal.id.split("-");
          let selectedVariantsTitle: any = combVal.title
            .split("(")
            .reduce((preVal: any, currVal: any, index: number) => {
              if (index > 1) {
                return preVal + "(" + currVal;
              } else if (index === 1) {
                return currVal;
              } else {
                return "";
              }
            }, "")
            .replace(")", "")
            .split(",");
          selectedVariantsId.map((val: any, index: number) => {
            variantsSelected.push({
              id: val,
              title: selectedVariantsTitle,
            });
          });
        }
        if (Object.keys(innerTemp).length) {
          innerTemp = {
            ...innerTemp,
            images: combVal.dimensions.images,
            imageReader: combVal.dimensions.imageReader,
            selectedCombinations: variantsSelected,
          };
          combinationTemp.push(innerTemp);
        }
      });
      updatedObject = { ...updatedObject, combinations: combinationTemp };
    }
    if (temp.defaultTechnicalFields && temp.defaultTechnicalFields.length) {
      updatedObject = {
        ...updatedObject,
        defaultTechnicalFields: temp.defaultTechnicalFields,
      };
    }
    let apiService = new APICallService(
      product.addProduct,
      productJSON.addProduct({ product: updatedObject }),
      "",
      "",
      "",
      "",
      MasterProduct,
      selectedWarehouse?.value
    );
    let response = await apiService.callAPI();
    if (response) {
      navigate("/UProcure/products/master-products ");
      success(catalogue.draft);
      setProductAsDraftModalShow(false);
       
    }
    setLoading(false);
  };
  console.log('generalData', generalData)
  return (
    <>
      <ProductAsDraft
        show={productAsDraftmodalShow}
        onHide={() => setProductAsDraftModalShow(false)}
        onSaveAsDraft={onSaveAsDraft}
        loading={loading}
      />
      <ProductAddedSuccessfully
        show={productAddedmodalShow}
        onHide={() => {
          setProductAddedModalShow(false);
        }}
        modalImage={modalImage}
        onSaveAsDraft={() => {
          navigate("/UProcure/products/master-products");
          setProductAddedModalShow(false);
          // success(catalogue.added);
        }}
      />
      {currentTab.value === 3 ? (
        <ProductGuidelines
          show={productGuidelinesmodalShow}
          onHide={() => setProductGuidelinesModalShow(false)}
        />
      ) : (
        <></>
      )}
      {showVariantModal && (
        <RemoveVariants
          show={showVariantModal}
          onHide={() => {
            setNavTab(0, generalData, generalDataValidation);
            setShowVariantModal(false);
          }}
          generalData={generalData}
          onGeneralDataChange={onGeneralDataChange}
          validation={generalDataValidation}
          onNextTab={(tab: any, data: any, validation: any) => {
            setNavTab(tab, data, validation);
            setGeneralData(data)
            setShowVariantModal(false);
          }}
        />
      )}
      <div className="p-5">
        <Row className="mb-5">
          <Col sm>
            <h1 className="fs-22 fw-bolder">Add new product</h1>
          </Col>
          {!fetchLoader ? (
            <Col sm={"auto"}>
              <Button
                variant="white"
                className="btn-flush text-gray"
                type="button"
                disabled={
                  generalData.primaryCategory === "" ||
                  generalData.subCategory === "" ||
                  generalData.productTitle === ""
                    ? true
                    : false
                }
                onClick={() => {
                  setProductAsDraftModalShow(true);
                }}
              >
                Save as draft
              </Button>
            </Col>
          ) : (
            <></>
          )}
        </Row>
        {!fetchLoader ? (
          <Row>
            <Col lg={12}>
              <div className="border border-r10px px-lg-9 px-6 mb-8">
                <Row className="align-items-center">
                  <Col sm>
                    <div className="d-flex flex-md-row h-lg-70px h-md-60px">
                      <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                        {createTabs()}
                      </ul>
                    </div>
                  </Col>
                  {currentTab.value === 3 ? (
                    <Col sm={"auto"}>
                      <Button
                        variant=""
                        type="button"
                        className="btn btn-flush"
                        onClick={() => setProductGuidelinesModalShow(true)}
                      >
                        <span className="fs-18 fw-600 text-primary">
                          View image guideline
                        </span>
                      </Button>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </div>
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active">
                  <>{currentTab.content}</>
                  <Row className="align-items-center mt-8">
                    <Col xs="auto">
                      {currentTab.value === 0 ? (
                        <></>
                      ) : loading ? (
                        <></>
                      ) : (
                        <>
                          <Button
                            type="button"
                            className="uw-btn uw-btn-light uw-btn-lg btn btn-lg btn-light btnPrev btn-active-light-primary "
                            onClick={() => {
                              handlePreviousSelectTab(
                                tab[
                                tab.findIndex(
                                  (val: any) => val.value === currentTab.value
                                ) - 1
                                ]
                              );
                            }}
                          >
                            Previous
                          </Button>
                        </>
                      )}
                      <Button
                        type="button"
                        className={clsx(
                          loading
                            ? "uw-btn uw-btn-lg btn btn-lg btnNext"
                            : "uw-btn uw-btn-lg btn btn-lg min-w-114px"
                        )}
                        onClick={() => {
                          currentTab.value !== 3
                            ? handleSelectTab(
                              tab[
                              tab.findIndex(
                                (val: any) => val.value === currentTab.value
                              ) + 1
                              ]
                            )
                            : handleSubmit();
                        }}
                        disabled={loading}
                      >
                        {!loading && (
                          <span className="indicator-label">
                            {currentTab.value === 3 ? "Finish" : "Next"}
                          </span>
                        )}
                        {loading && (
                          <span
                            className="indicator-progress fs-16 fw-bold"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoader} />
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default AddNewProduct;
